import { getFetchWrapper } from "@syf-api-library/core";
import { paymentMethodsUrl } from "../endpoints.js";
const mutationFnFactory = (config, keyProps, headers = {}) => {
  const fetchWrapper = getFetchWrapper(config);
  return (payload) => {
    const { paymentMedium } = payload;
    if (paymentMedium !== "E_CHECK") {
      const { paymentCardInfo } = payload;
      return fetchWrapper(paymentMethodsUrl, {
        method: "POST",
        body: JSON.stringify({
          accountIdType: keyProps.accountIdType,
          "cipher.accountId": keyProps.accountId,
          paymentMedium,
          paymentCardInfo
        }),
        headers
      });
    }
    const { paymentMethod } = payload;
    return fetchWrapper(paymentMethodsUrl, {
      method: "POST",
      body: JSON.stringify({
        accountIdType: keyProps.accountIdType,
        "cipher.accountId": keyProps.accountId,
        paymentMedium,
        paymentMethod
      }),
      headers
    });
  };
};
export {
  mutationFnFactory as default
};
//# sourceMappingURL=mutation.js.map
